module.exports = __webpack_public_path__ + "img/fearful.f1083bca.png";